export default __webpack_public_path__ + "static/media/0068.799fdb17.png";